import api from '@/utils/api'
import { buildListQuery } from '@/utils/listQuery'

export default {
    getTeams(page, size) {
        let range = '?range=' + encodeURIComponent(`[${page - 1},${size}]`)
        return api.get(`teams` + (page ? range : ''))
    },

    getFilteredTeams(filter, page, size, sort) {
        return api.get(`teams` + buildListQuery({ filter, page, size, sort }))
    },
    getTeam(id) {
        return api.get(`teams/${id}`)
    },

    updateTeam(id, data) {
        return api.put(`teams/${id}`, data)
    },

    // the match colour only (null: back to the team colour)
    setMatchColor(id, color) {
        return api.put(`teams/${id}/match-color`, { color })
    },

    createTeam(data) {
        return api.post('teams', data)
    },

    uploadFile(formData) {
        return api.uploadFile('uploads/team', formData)
    },

    deleteTeam(id) {
        return api.delete(`teams/${id}`)
    }
}
